<div class="flex items-center justify-center p-4 sm:p-8 w-full min-h-screen confirmation-page-container">
  <div class="card pb-6 pt-8 sm:pt-10 px-6 sm:px-10 max-w-[440px] w-full">
    <!-- Logout icon button top-right -->
    <div class="card-top-right">
      <button mat-icon-button class="logout-btn" (click)="goToLogin()" matTooltip="{{ 'EmailVerification.BtnLogout' | translate }}" matTooltipPosition="left">
        <mat-icon>logout</mat-icon>
      </button>
    </div>

    <!-- Logo -->
    <div class="flex justify-center">
      <img class="signin-logo" src="assets/creatives/logo-w70.png" alt="SkillzTank logo" />
    </div>

    <!-- Status Icons — bare, no circle -->
    <div class="flex justify-center mb-2">
      @if (status() === 'pending') {
        <mat-progress-spinner mode="indeterminate" diameter="48" strokeWidth="3" class="status-spinner"></mat-progress-spinner>
      } @else if (status() === 'success') {
        <mat-icon class="status-icon status-icon--success">check</mat-icon>
      } @else {
        <mat-icon class="status-icon status-icon--error">close</mat-icon>
      }
    </div>

    <!-- Status Message -->
    <h2 class="text-lg font-bold text-[#1D2433] mb-2 text-center">
      @if (status() === 'success') {
        {{ 'EmailVerification.Confirmed' | translate }}
        <span class="flickering-dots">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      } @else {
        {{ message() | translate }}
      }
    </h2>

    @if (status() === 'success') {
      <p class="text-sm text-[#5B6372] text-center">{{ 'EmailVerification.Redirecting' | translate }}</p>
    }

    <!-- Trust footer -->
    <div class="flex items-center justify-center gap-1.5 mt-8 text-gray-400 text-xs">
      <mat-icon class="text-[14px]! h-3.5! w-3.5!">lock</mat-icon>
      <span>{{ 'Sessions.Login.SecureConnection' | translate }}</span>
    </div>
  </div>
</div>
